export enum TraceEventType {
  Exception = 0,
  Information = 1
}